export function addZero (i) {
  if (i < 10) {
    i = '0' + i
  }
  return i
}

export const toString = date => {
  try {
    const day = date.getDate()
    const month = date.getMonth()
    const year = date.getFullYear()

    const esMonths = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    return `${day} / ${esMonths[month]} / ${year}`
  } catch (error) {
    return false
  }
}

export const addDays = (dateOrString, days) => {
  var date = typeof dateOrString === 'string' ? new Date(dateOrString) : dateOrString
  date.setDate(date.getDate() + days)
  return date
}

// transform date into object with minutes and hours
export const getStringTime = (date) => {
  try {
    const minutes = date.getMinutes()
    const hours = date.getHours()
    return `${addZero(hours)}:${addZero(minutes)}`
  } catch (error) {
    return false
  }
}

export const getStringHourFormat12 = (date) => {
  try {
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours || 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + '' + ampm
    return strTime
  } catch (error) {
    return false
  }
}

export function addMinutes (date, minutes) {
  return new Date(date.getTime() + minutes * 60000)
}

export const getAllBlock = (init, end, interval, date) => {
  var blocks = [init]

  while (true) {
    const currentDate = addMinutes(blocks[blocks.length - 1], interval)
    if (currentDate < end) {
      blocks = [...blocks, currentDate]
    } else {
      break
    }
  }
  return blocks.map(block => {
    const scopedDate = new Date(block.getTime())
    scopedDate.setDate(date.getDate())
    scopedDate.setMonth(date.getMonth())
    scopedDate.setFullYear(date.getFullYear())

    return {
      stringHour: getStringTime(scopedDate),
      date: scopedDate,
      duration: interval
    }
  })
}

// transform hourBlock into array width and minutes all minutes as elemenet
export const fillBlock = (currentDate, duration) => {
  const apointmentFilled = []
  for (let index = 0; index < duration; index++) {
    currentDate = addMinutes(currentDate, 1)
    const currenTimeTransformed = getStringTime(currentDate)
    apointmentFilled.push(currenTimeTransformed)
  }
  return apointmentFilled
}
/**
 * @param {object} allBlock
 * @param {object} appointments
 */

export const getAvalibleBlocks = (allBlocks, appointments) => {
  const allBlockFilled = allBlocks.map(block => fillBlock(block.date, block.duration))
  const appointmentsFilled = appointments.map(block => fillBlock(block.date, block.duration))
  const allMinutesNotAvailable = []
  appointmentsFilled.forEach(filledBlock => {
    filledBlock.forEach(minuteOfFilledBlock => {
      allMinutesNotAvailable.push(minuteOfFilledBlock)
    })
  })

  const allBlockAvailable = allBlocks.filter((_, index) => {
    const currentBlockTesting = allBlockFilled[index]
    const valid = currentBlockTesting.every(currentMinuteTesting => {
      return !allMinutesNotAvailable.includes(currentMinuteTesting)
    })
    return valid
  })

  return allBlockAvailable
}

export const filterTimesPast = blocks => {
  const currentTime = new Date()
  return blocks.filter(block => {
    return block.date.getTime() > currentTime.getTime()
  })
}
